import React from 'react'
import CountUp from "react-countup";
function FeaturesArea() {
  
  return (
    <>
     <section className="features-area">
        <div className="container">
          <div className="title-wrap  wow animate fadeInUp" data-wow-delay="200ms" data-wow-duration="1500ms">
            <div className="sec-title white">
              <span>Impacto Real</span>
              <h2>Resultados y Experiencia</h2>
              <p>
                  Con una creciente lista de clientes satisfechos y un equipo de especialistas altamente capacitados, 
                  estamos comprometidos en ofrecer soluciones tecnológicas innovadoras y resultados de calidad en cada 
                  uno de nuestros servicios, desde <strong>desarrollos web simples </strong> hasta 
                  <strong> aplicaciones complejas que integran Inteligencia Artificial</strong>. 
                  Estos números reflejan nuestro esfuerzo, dedicación y pasión por cada proyecto que emprendemos, 
                  garantizando siempre la satisfacción total del cliente y superando sus expectativas.
              </p>
            </div>
          </div>
        </div>
      </section>   
    </>
  )
}

export default FeaturesArea